import { ssmTokenService } from "@/shared/services/token-service";
import { medicalUserService } from "./user-service";
import { JwtService } from "./JwtService";
import { RouterNames } from "@/router/routernames";

export default class RouterGuardService {
  public pathLogin: string = "/login";
  public pathmain: string = "/main";

  public beforeEnter(to: any, from: any, next: any) {
    if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
      next();
    } else {
      /*
                    Nos guardamos el path actual para que al iniciar sesión podamos volver a él
                    */
      ssmTokenService.setPathBeforeLogin(to.fullPath);
      next({
        name: RouterNames.Login,
        query: { redirect: to.fullPath },
      });
    }
  }

  public IsAdmin(to: any, from: any, next: any) {
    if (
      ssmTokenService.hasToken() &&
      medicalUserService.hasuser() &&
      JwtService.jwtIsAdmin()
    ) {
      next();
    } else {
      next(ssmRouterGuardService.pathmain);
    }
  }

  public setPathLogin(pathLogin: string) {
    ssmRouterGuardService.pathLogin = pathLogin;
  }
}

export const ssmRouterGuardService = new RouterGuardService();
